import VueI18n from 'vue-i18n'
import en from '../../../lang/en.json'
import de from '../../../lang/de.json'
import fr from '../../../lang/fr.json'

window.Vue = window.Vue.use(VueI18n);

const messages = {
    en: {
        ...en
    },
    de: {
        ...de
    },
    fr: {
        ...fr
    },
};

export default new VueI18n({
    locale: window.default_locale,
    fallbackLocale: window.fallback_locale,
    messages: messages,
});